<template>
  <div class="page-single">
    <div class="container">
      <div class="row">
        <div class="col col-login mx-auto">
          <div class="text-center mb-8">
            <img src="../../assets/Goalpilot_logo_white_500.png" class="h-6" alt="">
          </div>

          <h2 class="text-center mb-8">Account is being created... please wait</h2>

          <img :src="loading_img">

          <!-- <pre>{{userReadonly}}</pre> -->

          <div v-if="userReadonly.status === 'init'" class="mt-8">
            Waiting...
          </div>

          <div v-if="userReadonly.status === 'creating'" class="mt-8">
            Looking good...
          </div>

          <div v-if="show_additional_options" class="mt-8 text-center">
            Nothing happens?
            Contact support@goalpilot.com
            <br />
            <br />
            <el-button @click="onLogout">Logout</el-button>
            <el-button @click="onGoToActivation">Go to activation</el-button>
            <!-- <el-button @click="onReactiveate">Reactiveate</el-button> -->
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_additional_options: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.show_additional_options = true
    }, 15000)
  },
  computed: {
    userReadonly() {
      return this.$models.userReadonly.subscribeNode( this.$models.user.defaultUserId )
    },
    loading_img() {
      const GIF_LIST = [
        'https://media.giphy.com/media/3o7btYwB37GcedktcQ/giphy.gif',
        'https://media.giphy.com/media/3ov9jZUXYl6rQMlPri/giphy.gif',
        'https://media.giphy.com/media/3bYL6cwayJOA8/giphy.gif' ]

      return GIF_LIST[ Math.round( Math.random() * 2 ) ]
    }
  },
  methods: {
    onLogout() {
      this.$api.auth_logout()
      this.$router.push('/login')
    },
    onGoToActivation() {
      this.$router.push('/confirm-invitation')
    },
    onReactiveate() {
      // this.$prompt....
      // this.$api.auth_check_invitation_code({
      //   code: this.code,
      //   email: firebase.auth().currentUser.email
      // }).then(e => {
      //   console.log(e)
      // })
    }
  }
};
</script>

<style>
</style>
